export default {
  contract: {
    header: {
      title: "Hemmeligholdelsesaftale",
    },
    parties: {
      headline: "Mellem",
      and: "og",
      label: {
        company: 'herefter kaldet "Udleverende Part" (Part 1)',
        supplier: 'herefter kaldet "Modtagende Part" (Part 2)',
        cvr: "CVR-nr.:",
      },
      placeholder: {
        name: "[Navn]",
        address: "[Adresse]",
        cvr: "[CVR-nummer]",
      },
    },
    agreement: {
      paragraphOne:
        "indgås nærværende hemmeligholdelsesaftale vedrørende de fortrolige oplysninger, som Part 2 måtte modtage fra Part 1 i anledning af {description}",
      placeholder: {
        description: "[aftalebeskrivelsen]",
      },
    },
    confidentialInfo: {
      headline: "1. Fortrolige oplysninger",
      paragraphOne:
        '1.1 "Fortrolige oplysninger” betyder alle informationer, oplysninger og data om Part 1 eller dennes kommercielle anliggender, herunder produktion, drift, produkter, ydelser, knowhow, forskning, processer, tekniske informationer, prøver, modeller, tegninger, apparater og alle lignende informationer, oplysninger og data.',
      paragraphTwo:
        '1.2 "Fortrolige oplysninger" betyder endvidere alle informationer, oplysninger og data, herunder persondata, om Part 1s medarbejdere og kunder.',
      paragraphThree:
        '1.3 Endelig betragtes det forhold, at der finder overvejelser og drøftelser eller forhandlinger sted vedrørende {description} samt vilkår, betingelser og andre forhold vedrørende dette, herunder status herpå, som "fortrolige oplysninger".',
      paragraphFour:
        '1.4 "Fortrolige oplysninger” omfatter informationer, oplysninger og data i skriftlig og mundtlig form såvel som i enhver anden fremtrædelsesform.',
      paragraphFive:
        "1.5 Oplysninger, der er offentligt tilgængelige, anses ikke for fortrolige oplysninger.",
        placeholder: {
          description: "[aftalebeskrivelsen]"
        }
    },
    supplierObligations: {
      headline: "2. Den modtagende Parts forpligtelser",
      paragraphOne:
        "2.1 Part 2 forpligter sig i henhold til denne hemmeligholdelsesaftale til:",
      paragraphOne_1:
        "<i><strong>at</strong></i> hemmeligholde fortrolige oplysninger og afholde sig fra at videregive sådanne oplysninger til tredjemand, medmindre videregivelsen er nødvendig for at kunne udføre den aftalte opgave, eller videregivelsen sker til Part 2s juridiske rådgiver eller revisor, eller andre rådgivere, der er undergivet en lovbestemt tavshedspligt,",
      paragraphOne_2:
        "<i><strong>at</strong></i> afholde sig fra at opbevare, kopiere, reproducere eller distribuere fortrolige oplysninger til eget eller tredjemands brug,",
      paragraphOne_3:
        "<i><strong>at</strong></i> træffe rimelige foranstaltninger for at sikre, at der ikke i forbindelse med Part 2s udførelse af eventuelt aftalte opgaver Parterne imellem, utilsigtet sker bortfjernelse af dokumenter eller andre databærere indeholdende fortrolige oplysninger fra Part 1,",
      paragraphOne_4:
        "<i><strong>at</strong></i> alene anvende de fortrolige oplysninger til opfyldelse af eller i relation til [formål med mødet eller samarbejdet], og",
      paragraphOne_5:
        "<i><strong>at</strong></i> tilbagelevere eller destruere materiale indeholdende fortrolige oplysninger, såfremt Part 1 anmoder herom.",
    },
    contractDuration: {
      headline: "3. Hemmeligholdelsesforpligtelsens varighed",
      paragraphOne:
        "Den af Aftalen følgende hemmeligholdelsesforpligtigelse skal være gældende så længe og i det omfang oplysninger og materiale udleveret under Aftalen kvalificeres som fortrolige oplysninger i henhold til Aftalens punkt 1. Hemmeligholdelsesforpligtigelsen skal således fortsat være gældende, hvis Formålet som angivet i indledningen af denne hemmeligholdelsesaftale bortfalder.",
    },
    violation: {
      headline: "4. Overtrædelse",
      placeholder: {
        amount: "[beløb]",
      },
      paragraphOne:
        "4.1 Såfremt Part 2 tilsidesætter sine forpligtelser efter denne aftale, skal Part 2 betale en konventionalbod til Part 1 med {amount} kr. for hver tilsidesættelse, medmindre Part 1 beviser, at den faktiske skade er større, i hvilket tilfælde Part 1 er berettiget til at få den faktiske skade erstattet.",
      paragraphTwo:
        "4.2 Betaling af konventionalbod eller erstatning fritager ikke Part 2 for forpligtelserne i denne hemmeligholdelsesaftale.",
      paragraphThree:
        "4.3 Ulovlig erhvervelse, brug og videregivelse af forretningshemmeligheder kan i øvrigt sanktioneres i overensstemmelse med lov om forretningshemmeligheder. Der kan i den forbindelse også fastsættes en godtgørelse til Part 1 for ikke-økonomisk skade, jf. § 15, stk. 4, i lov om forretningshemmeligheder.",
    },
    applicableLaw: {
      headline: "5. Lovvalg og værneting",
      paragraphOne: "5.1 Hemmeligholdelsesaftalen er undergivet dansk ret.",
      paragraphTwo:
        "5.2 Enhver tvist, som måtte opstå i forbindelse med nærværende aftale, skal søges løst ved mediation gennem Mediationsinstituttet i overensstemmelse med de til enhver tid gældende regler for behandling af sager ved Mediationsinstituttet (www.mediationsinstituttet.dk).",
      paragraphThree:
        "5.3 Når en tvist er opstået mellem parterne, er hver part berettiget til at indgive begæring til Mediationsinstituttet om påbegyndelse af mediation.",
      paragraphFour:
        "5.4 Hvis tvisten ikke løses ved gennemført mediation, er hver part berettiget til at kræve tvisten afgjort {rules}.",
      placeholder: {
        rules: "[tvister afgøres ved...]",
      },
      rulesValues: {
        voldgift: "ved voldgift efter reglerne ved Det danske Voldgiftinstitut",
        retten: "ved de almindelige danske domstole",
      },
    },
    signature: {
      date_label: "Dato:",
      company1_label: "Firmanavn [Part 1]: ",
      company2_label: "Firmanavn [Part 2]: ",
      signature_label: "Navn [Underskrift]:",
    },
  },
};



// WEBPACK FOOTER //
// ./src/apps/hemmelig/translations/contract/da_contract.js